<template>
  <div class="container mt-5">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <page-header
          title="Delivery Zones"
          :return_button="false"
          :action_button="true"
          action_button_text="New Delivery Zone"
          action_button_link="/staff/delivery-zones/add"
        ></page-header>
        <div class="row">
          <div class="col-md-12">
            <div v-if="!loading.page && deliveryZones.length > 0">
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Name</th>
                    <th scope="col">Locations</th>
                    <th scope="col">Price</th>
                    <th scope="col" class="text-end">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="deliveryZone in deliveryZones" :key="deliveryZone.id">
                    <th scope="row">{{ deliveryZone.id }}</th>
                    <td>{{ deliveryZone.name }}</td>
                    <td class="fw-bolder">{{ deliveryZone.locations }}</td>
                    <td>
                      <span class="currency_code">GH₵</span>
                      <b> {{ deliveryZone.cost }}</b>
                    </td>
                    <td class="text-end">
                      <a :href="`/staff/delivery-zones/${deliveryZone.id}/view`">
                        <i class="bi-pencil-square fs-5 text-primary me-2"></i>
                      </a>
                      <i class="bi-trash fs-5 text-danger"></i>
                    </td>
                  </tr>
                </tbody>
              </table>
              <nav>
                <ul class="pagination justify-content-center mt-5">
                  <li v-if="pagination.currentPage > 1" class="page-item">
                    <a
                      class="page-link"
                      href="#"
                      aria-label="Previous"
                      @click.prevent="changePage(pagination.currentPage - 1)"
                    >
                      <span aria-hidden="true">«</span>
                    </a>
                  </li>
                  <li
                    class="page-item"
                    v-for="page in pagination.totalPages"
                    :key="page"
                    :class="{ active: page == pagination.currentPage }"
                  >
                    <a
                      v-if="
                        page < 3 ||
                        page > pagination.totalPages - 3 ||
                        (page < pagination.currentPage + 3 &&
                          page > pagination.currentPage - 3)
                      "
                      class="page-link"
                      @click.prevent="changePage(page)"
                      >{{ page }}</a
                    >
                  </li>
                  <li
                    v-if="pagination.currentPage < pagination.totalPages"
                    class="page-item"
                  >
                    <a
                      class="page-link"
                      aria-label="Next"
                      @click.prevent="changePage(pagination.currentPage + 1)"
                    >
                      <span aria-hidden="true">»</span>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>

            <loader v-if="loading.page"> </loader>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/layout/navigation/PageHeader.vue";
import Loader from "@/components/Loader.vue";
import DeliveryZoneService from "@/services/staff/DeliveryZoneService";

export default {
  name: "ListDeliveryZonesView",
  components: {
    PageHeader,
    Loader,
  },

  data() {
    return {
      loading: {
        page: false,
      },
      deliveryZones: [],
      pagination: {
        currentPage: 1,
        perPage: 12,
        totalRows: 0,
        totalPages: 0,
      },
    };
  },

  async mounted() {
    await this.getRecords();
    this.loading.page = false;
  },

  methods: {
    async getRecords(search) {
      this.loading.page = true;
      if (search === true) {
        this.pagination.currentPage = 1;
      }

      let response = await DeliveryZoneService.getDeliveryZones(
        this.pagination.currentPage,
        this.pagination.perPage
      );

      this.deliveryZones = response.data.delivery_zones.data;
      this.pagination.totalRows = response.data.delivery_zones.total;
      this.loading.page = false;
      this.pagination.totalPages = response.data.delivery_zones.last_page;
    },

    changePage(page) {
      if (this.pagination.currentPage != page) {
        this.pagination.currentPage = page;
        this.getRecords();
      }
    },
  },
};
</script>
